import React, { useEffect, useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import './DashboardTreinador.css';
import TeamDetailsModal from '../../components/TeamDetailsModal/TeamDetailsModal';
import CalendarModal from '../../components/CalendarModal/CalendarModal';
import CalendarManager from '../../components/Admin/CalendarManager';
import EventAttendanceModal from '../../components/Attendance/EventAttendanceModal';
import TeamAttendanceHistoryModal from '../../components/Attendance/TeamAttendanceHistoryModal';
import TeamCallUpHistoryModal from '../../components/Attendance/TeamCallUpHistoryModal';
import GameCallUpModal from '../../components/Game/GameCallUpModal';
import FamilyAssociationModal from '../../components/FamilyAssociationModal/FamilyAssociationModal';
import PaymentCard from '../../components/Payment/PaymentCard';
import ReceiptsModal from '../../components/ReceiptsModal/ReceiptsModal';
import EditProfileModal from '../../components/EditProfileModal/EditProfileModal';
import NotificationModal from '../../components/NotificationModal/NotificationModal';
import TicketsModal from '../../components/TicketsModal/TicketsModal';
import ChangePinModal from '../../components/ChangePinModal/ChangePinModal';
import AdminPinModal from '../../components/AdminPinModal/AdminPinModal';
import ConsentRequestModal from '../../components/ConsentRequestModal/ConsentRequestModal';
import FamilyPrivacyModal from '../../components/FamilyPrivacyModal/FamilyPrivacyModal';
import { FaLock, FaShieldAlt } from 'react-icons/fa';
import DocumentsModal from '../../components/DocumentsModal/DocumentsModal';
import MembershipCard, { getCardPaymentState } from '../../components/MembershipCard/MembershipCard';
import API_BASE_URL from '../../config/api';

const DashboardTreinador = () => {
    const navigate = useNavigate();
    const userRoles = (() => { try { return JSON.parse(localStorage.getItem('roles') || '[]').map(r => r.toLowerCase()); } catch { return []; } })();
    const isAlsoAtleta = userRoles.includes('atleta');
    const isAlsoCoordenador = userRoles.includes('coordenador') || userRoles.includes('coordinator');
    const location = useLocation();
    const [coachData, setCoachData] = useState(null);
    const [teamData, setTeamData] = useState(null);
    const [events, setEvents] = useState([]);
    const [loading, setLoading] = useState(true);
    const [teamLoading, setTeamLoading] = useState(false);
    const [selectedTeamId, setSelectedTeamId] = useState(null);
    const [error, setError] = useState(null);
    const [isTeamModalOpen, setIsTeamModalOpen] = useState(false);
    const [isCalendarModalOpen, setIsCalendarModalOpen] = useState(false);
    const [showCalendarManager, setShowCalendarManager] = useState(false);
    const [activeEventTab, setActiveEventTab] = useState('upcoming'); // 'upcoming' | 'past'
    const [pastEvents, setPastEvents] = useState([]);

    const [isAttendanceHistoryOpen, setIsAttendanceHistoryOpen] = useState(false);
    const [isCallUpHistoryOpen, setIsCallUpHistoryOpen] = useState(false);
    const [isAttendanceModalOpen, setIsAttendanceModalOpen] = useState(false);
    const [selectedEventForAttendance, setSelectedEventForAttendance] = useState(null);
    const [lastTrainingStats, setLastTrainingStats] = useState(null);
    const [teamStats, setTeamStats] = useState(null);
    const [teamRecord, setTeamRecord] = useState({ wins: 0, losses: 0, draws: 0 });
    const [athletePayments, setAthletePayments] = useState({});

    const [isCallUpModalOpen, setIsCallUpModalOpen] = useState(false);
    const [selectedEventForCallUp, setSelectedEventForCallUp] = useState(null);
    const [isFamilyModalOpen, setIsFamilyModalOpen] = useState(false);
    const [isReceiptsModalOpen, setIsReceiptsModalOpen] = useState(false);
    const [isEditModalOpen, setIsEditModalOpen] = useState(false);
    const [isNotificationModalOpen, setIsNotificationModalOpen] = useState(false);
    const [isTicketsModalOpen, setIsTicketsModalOpen] = useState(false);
    const [isPinModalOpen, setIsPinModalOpen] = useState(false);
    const [isDocumentsModalOpen, setIsDocumentsModalOpen] = useState(false);
    const [showAdminPinModal, setShowAdminPinModal] = useState(false);
    const [pendingSwitchUser, setPendingSwitchUser] = useState(null);

    const handleSaveProfile = (updatedData) => {
        setCoachData(prev => ({ ...prev, ...updatedData }));
        if (updatedData.firstName && updatedData.lastName) {
            localStorage.setItem('userName', `${updatedData.firstName} ${updatedData.lastName}`);
        }
    };

    const [linkedUsers, setLinkedUsers] = useState(() => {
        try {
            const stored = localStorage.getItem('linkedUsers');
            return stored ? JSON.parse(stored) : [];
        } catch { return []; }
    });
    const currentUserId = parseInt(localStorage.getItem('userId')) || null;
    const [isSwitchingUser, setIsSwitchingUser] = useState(false);
    const [switchingToName, setSwitchingToName] = useState('');

    const [paymentReference, setPaymentReference] = useState(null);
    const [paymentStatus, setPaymentStatus] = useState('unpaid');
    const [generatingReference, setGeneratingReference] = useState(false);
    const [startingPayment, setStartingPayment] = useState(false);
    const [quotaAmount, setQuotaAmount] = useState(null);
    const [totalDue, setTotalDue] = useState(null);
    const [overdueMonths, setOverdueMonths] = useState([]);
    const [futureMonths, setFutureMonths] = useState([]);
    const [paymentPreference, setPaymentPreference] = useState('Monthly');
    const [nextPeriod, setNextPeriod] = useState(null);
    const [paymentHistory, setPaymentHistory] = useState([]);
    const [historyInscriptions, setHistoryInscriptions] = useState([]);
    const [historyYear, setHistoryYear] = useState(new Date().getFullYear());
    const [quotaBreakdown, setQuotaBreakdown] = useState([]);
    const [discountsApplied, setDiscountsApplied] = useState([]);
    const [inscriptionInfo, setInscriptionInfo] = useState([]);
    const [parentsPaymentWarning, setParentsPaymentWarning] = useState(false);
    const [paymentToast, setPaymentToast] = useState(null);

    const [refreshKey, setRefreshKey] = useState(0);
    const [isPollingPayment, setIsPollingPayment] = useState(false);

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const paymentParam = params.get('payment');
        const redirectStatus = params.get('redirect_status');

        if (paymentParam === 'success') {
            if (redirectStatus === 'failed') {
                setPaymentToast('cancelled');
                setIsPollingPayment(false);
                window.history.replaceState({}, '', location.pathname);
                const timer = setTimeout(() => setPaymentToast(null), 6000);
                return () => clearTimeout(timer);
            } else {
                setIsPollingPayment(true);
                window.history.replaceState({}, '', location.pathname);
            }
        } else if (paymentParam === 'cancelled') {
            setPaymentToast('cancelled');
            window.history.replaceState({}, '', location.pathname);
            const timer = setTimeout(() => setPaymentToast(null), 6000);
            return () => clearTimeout(timer);
        }
    }, [location.search]);

    // Background polling for payment status completion
    useEffect(() => {
        if (!isPollingPayment || !currentUserId) return;

        let attempt = 0;
        const maxAttempts = 10;

        const interval = setInterval(async () => {
            attempt++;
            if (attempt >= maxAttempts) {
                setIsPollingPayment(false);
                clearInterval(interval);
                return;
            }

            try {
                const token = localStorage.getItem('token');
                const response = await fetch(`${API_BASE_URL}/api/payment/quota?userId=${currentUserId}`, {
                    headers: { 'Authorization': `Bearer ${token}` }
                });
                if (response.ok) {
                    const quotaData = await response.json();
                    if (quotaData.status === 'Regularizada' || (quotaData.totalDue ?? 0) === 0) {
                        setRefreshKey(prev => prev + 1);
                        setIsPollingPayment(false);
                        clearInterval(interval);
                    }
                }
            } catch (err) {
                console.error("Payment status polling error:", err);
            }
        }, 3000);

        return () => clearInterval(interval);
    }, [isPollingPayment, currentUserId]);

    useEffect(() => {
        if (!currentUserId) return;
        const fetchPaymentData = async () => {
            try {
                const token = localStorage.getItem('token');

                const quotaResponse = await fetch(`${API_BASE_URL}/api/payment/quota?userId=${currentUserId}`, {
                    headers: { 'Authorization': `Bearer ${token}` }
                });
                if (quotaResponse.ok) {
                    const quotaData = await quotaResponse.json();
                    setQuotaAmount(quotaData.amount);
                    setPaymentStatus(quotaData.status);
                    setPaymentReference(quotaData.existingPayment || null);
                    setPaymentPreference(quotaData.paymentPreference || 'Monthly');
                    setQuotaBreakdown(quotaData.breakdown || []);
                    setDiscountsApplied(quotaData.discountsApplied || []);
                    setInscriptionInfo(quotaData.inscriptionInfo || []);
                    setOverdueMonths(quotaData.overdueMonths || []);
                    setFutureMonths(quotaData.futureMonths || []);
                    setTotalDue(quotaData.totalDue ?? null);
                    setParentsPaymentWarning(quotaData.parentsPaymentWarning || false);
                    if (quotaData.nextPeriodYear) {
                        setNextPeriod({ month: quotaData.nextPeriodMonth, year: quotaData.nextPeriodYear });
                    }
                }

                const historyResponse = await fetch(`${API_BASE_URL}/api/payment/history?userId=${currentUserId}&year=${historyYear}`, {
                    headers: { 'Authorization': `Bearer ${token}` }
                });
                if (historyResponse.ok) {
                    const historyData = await historyResponse.json();
                    setPaymentHistory(Array.isArray(historyData) ? historyData : (historyData.payments || []));
                    setHistoryInscriptions(Array.isArray(historyData) ? [] : (historyData.inscriptions || []));
                }
            } catch (err) {
                console.error('Error fetching payment data:', err);
            }
        };
        fetchPaymentData();
    }, [currentUserId, historyYear, refreshKey]);
    const handleStartPayment = (selectedOverdueMonths = null, includesCurrentMonth = true, selectedAmount = null, selectedFutureMonths = [], currentMonthItem = null) => {
        const token = localStorage.getItem('token');
        if (!token) { navigate('/login'); return; }

        const isAnnual = paymentPreference === 'Annual';

        // Future months are merged in — they're just additional periods from the backend's perspective
        const effectiveOverdue = [
            ...(selectedOverdueMonths !== null ? selectedOverdueMonths : overdueMonths),
            ...(selectedFutureMonths || [])
        ];
        const effectiveAmount = selectedAmount !== null
            ? selectedAmount
            : (overdueMonths.length > 0 ? totalDue : quotaAmount);

        const finalMonth = includesCurrentMonth
            ? (isAnnual ? null : (new Date().getMonth() + 1))
            : null;
        const finalYear = includesCurrentMonth ? new Date().getFullYear() : null;

        let description = 'Quota';
        const totalMonths = effectiveOverdue.length + (includesCurrentMonth ? 1 : 0);
        if (effectiveOverdue.length > 0 && !includesCurrentMonth) {
            description = `Quotas — ${effectiveOverdue.length} ${effectiveOverdue.length === 1 ? 'mês' : 'meses'}`;
        } else if (effectiveOverdue.length > 0) {
            description = `Quotas — ${totalMonths} ${totalMonths === 1 ? 'mês' : 'meses'}`;
        } else if (finalYear) {
            if (isAnnual && finalMonth) {
                const startMonthName = new Date(finalYear, finalMonth - 1, 1).toLocaleDateString('pt-PT', { month: 'long' });
                const endMonth = finalMonth === 1 ? 12 : finalMonth - 1;
                const endYear = finalMonth === 1 ? finalYear : finalYear + 1;
                const endMonthName = new Date(endYear, endMonth - 1, 1).toLocaleDateString('pt-PT', { month: 'long' });
                description = `Quota Anual — ${startMonthName.charAt(0).toUpperCase() + startMonthName.slice(1)} de ${finalYear} a ${endMonthName.charAt(0).toUpperCase() + endMonthName.slice(1)} de ${endYear}`;
            } else {
                description = (!isAnnual && finalMonth)
                    ? `Quota Mensal — ${new Date(finalYear, (finalMonth - 1)).toLocaleDateString('pt-PT', { month: 'long', year: 'numeric' })}`
                    : `Quota Anual — ${finalYear}`;
            }
        }

        navigate('/checkout', {
            state: {
                type: 'quota',
                amount: effectiveAmount,
                description,
                selectedUserId: currentUserId,
                buyerEmail: coachData?.email || '',
                periodMonth: finalMonth,
                periodYear: finalYear,
                overdueMonths: effectiveOverdue,
                breakdown: currentMonthItem?.breakdown || quotaBreakdown,
                inscriptionInfo: currentMonthItem?.inscriptionInfo || inscriptionInfo,
                currentMonthDetails: currentMonthItem,
                isAnnual,
                successPath: '/dashboard-treinador',
                cancelPath: '/dashboard-treinador',
                queryParams: '?payment=success',
            }
        });
    };


    const refreshLinkedUsers = async () => {
        try {
            const token = localStorage.getItem('token');
            const primaryUserId = localStorage.getItem('primaryUserId');
            if (!token) return;
            const res = await fetch(`${API_BASE_URL}/api/auth/linked-users?primaryUserId=${primaryUserId || ''}`, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'X-Primary-User-Id': primaryUserId || ''
                }
            });
            if (res.ok) {
                const data = await res.json();
                setLinkedUsers(data);
                if (data.length > 0) {
                    localStorage.setItem('linkedUsers', JSON.stringify(data));
                } else {
                    localStorage.removeItem('linkedUsers');
                }
            }
        } catch (err) {
            console.warn('Could not refresh linked users:', err);
        }
    };

    useEffect(() => {
        refreshLinkedUsers();
    }, []);

    const [showConsentModal, setShowConsentModal] = useState(false);
    const [targetConsentUser, setTargetConsentUser] = useState(null);
    const [isPrivacyModalOpen, setIsPrivacyModalOpen] = useState(false);

    const handleLinkedTabClick = async (lu) => {
        if (currentUserId === lu.id) return;

        if (lu.requiresConsent) {
            setTargetConsentUser(lu);
            setShowConsentModal(true);
            return;
        }

        const type = lu.dashboardType?.toLowerCase() || 'socio';
        if (type === 'admin' || lu.requiresPin) {
            setPendingSwitchUser(lu);
            setShowAdminPinModal(true);
            return;
        }

        executeUserSwitch(lu);
    };

    const executeUserSwitch = async (lu) => {
        setIsSwitchingUser(true);
        setSwitchingToName(`${lu.firstName} ${lu.lastName}`);
        try {
            const token = localStorage.getItem('token');
            const primaryUserId = localStorage.getItem('primaryUserId');
            const res = await fetch(`${API_BASE_URL}/api/auth/switch-user`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`,
                    'X-Primary-User-Id': primaryUserId || ''
                },
                body: JSON.stringify({ targetUserId: lu.id, primaryUserId: primaryUserId ? parseInt(primaryUserId) : null })
            });

            if (res.ok) {
                const data = await res.json();
                localStorage.setItem('token', data.token);
                localStorage.setItem('userId', data.id.toString());
                localStorage.setItem('roles', JSON.stringify(data.roles));
                localStorage.setItem('userName', `${data.firstName} ${data.lastName}`);
                localStorage.setItem('userEmail', data.email);

                const dashboardRoutes = {
                    atleta: '/dashboard-atleta',
                    treinador: '/dashboard-treinador',
                    coordenador: '/dashboard-coordenador',
                    socio: '/dashboard-socio',
                    admin: '/dashboard-admin',
                    user: '/dashboard-socio'
                };
                const type = lu.dashboardType?.toLowerCase() || 'socio';
                navigate(dashboardRoutes[type] || '/dashboard-socio');
                window.location.reload();
            } else {
                const err = await res.json().catch(() => ({}));
                alert(err.message || 'Erro ao alterar perfil');
                setIsSwitchingUser(false);
            }
        } catch (err) {
            console.error('Error switching user:', err);
            setIsSwitchingUser(false);
        }
    };

    const fetchTeamData = async (teamId) => {
        if (!teamId) return;
        setTeamLoading(true);
        try {
            const token = localStorage.getItem('token');
            const teamResponse = await fetch(`${API_BASE_URL}/api/teams/${teamId}`, {
                headers: { 'Authorization': `Bearer ${token}` }
            });

            if (teamResponse.ok) {
                const team = await teamResponse.json();
                setTeamData(team);

                const todayStart = new Date();
                const todayStartLocal = `${todayStart.getFullYear()}-${String(todayStart.getMonth() + 1).padStart(2, '0')}-${String(todayStart.getDate()).padStart(2, '0')}T00:00:00`;

                const eventsResponse = await fetch(`${API_BASE_URL}/api/events?teamId=${teamId}&startDate=${todayStartLocal}`, {
                    headers: { 'Authorization': `Bearer ${token}` }
                });
                if (eventsResponse.ok) {
                    const eventsData = await eventsResponse.json();
                    setEvents(eventsData.sort((a, b) => new Date(a.startDateTime) - new Date(b.startDateTime)).slice(0, 3));
                }

                const pastTrainingsResponse = await fetch(`${API_BASE_URL}/api/events?teamId=${teamId}&eventType=2&endDate=${todayStartLocal}`, {
                    headers: { 'Authorization': `Bearer ${token}` }
                });
                if (pastTrainingsResponse.ok) {
                    const pastTrainings = await pastTrainingsResponse.json();
                    setPastEvents(pastTrainings.sort((a, b) => new Date(b.startDateTime) - new Date(a.startDateTime)).slice(0, 5));

                    if (pastTrainings.length > 0) {
                        const lastTraining = pastTrainings[0];
                        const attResponse = await fetch(`${API_BASE_URL}/api/attendance/event/${lastTraining.id}`, {
                            headers: { 'Authorization': `Bearer ${token}` }
                        });
                        if (attResponse.ok) {
                            const attendanceData = await attResponse.json();
                            const totalAthletes = team.athletes.length;
                            const presentCount = attendanceData.filter(a => a.status === 1 || a.status === 3).length;
                            const attendanceRate = totalAthletes > 0 ? Math.round((presentCount / totalAthletes) * 100) : 0;
                            setLastTrainingStats({
                                date: lastTraining.startDateTime,
                                rate: attendanceRate,
                                present: presentCount,
                                total: totalAthletes,
                                details: attendanceData
                            });
                        }
                    } else {
                        setLastTrainingStats(null);
                    }
                }

                const statsResponse = await fetch(`${API_BASE_URL}/api/attendance/team-stats/${teamId}`, {
                    headers: { 'Authorization': `Bearer ${token}` }
                });
                if (statsResponse.ok) {
                    const statsData = await statsResponse.json();
                    setTeamStats(statsData);
                }

                const recordResponse = await fetch(`${API_BASE_URL}/api/teams/${teamId}/stats`, {
                    headers: { 'Authorization': `Bearer ${token}` }
                });
                if (recordResponse.ok) {
                    const recordData = await recordResponse.json();
                    setTeamRecord(recordData);
                }

                const paymentsResponse = await fetch(`${API_BASE_URL}/api/payment/team-status/${teamId}`, {
                    headers: { 'Authorization': `Bearer ${token}` }
                });
                if (paymentsResponse.ok) {
                    const paymentsData = await paymentsResponse.json();
                    setAthletePayments(Object.fromEntries(paymentsData.map(p => [p.userId, p])));
                }
            }
        } catch (err) {
            console.error('Error fetching team data:', err);
        } finally {
            setTeamLoading(false);
        }
    };

    const fetchData = async () => {
        try {
            const userId = localStorage.getItem('userId');
            const token = localStorage.getItem('token');
            if (!userId || !token) {
                navigate('/login?redirect=/dashboard-treinador');
                return;
            }

            const userResponse = await fetch(`${API_BASE_URL}/api/users/${userId}`, {
                headers: { 'Authorization': `Bearer ${token}` }
            });
            if (userResponse.status === 401) {
                localStorage.removeItem('token');
                navigate('/login?redirect=/dashboard-treinador');
                return;
            }
            if (!userResponse.ok) throw new Error(`Falha ao carregar dados do treinador (${userResponse.status})`);

            const userData = await userResponse.json();
            setCoachData(userData);

            const teams = userData.coachProfile?.teams || [];
            if (teams.length > 0) {
                const sortedTeams = [...teams].sort((a, b) => (b.season || '').localeCompare(a.season || ''));
                const initialTeamId = (selectedTeamId && sortedTeams.some(t => t.id === selectedTeamId))
                    ? selectedTeamId
                    : sortedTeams[0].id;
                setSelectedTeamId(initialTeamId);
                fetchTeamData(initialTeamId);
            }
        } catch (err) {
            console.error('Error fetching data:', err);
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        window.scrollTo(0, 0);
        fetchData();

        const handleRefresh = () => {
            if (selectedTeamId) fetchTeamData(selectedTeamId);
        };
        window.addEventListener('dashboardRefresh', handleRefresh);
        return () => window.removeEventListener('dashboardRefresh', handleRefresh);
    }, [selectedTeamId]);

    if (loading) {
        const storedName = localStorage.getItem('userName');
        return (
            <div style={{
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: 'rgba(0, 15, 38, 0.9)',
                backdropFilter: 'blur(10px)',
                WebkitBackdropFilter: 'blur(10px)',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                zIndex: 99999,
                animation: 'fadeInOverlay 0.3s ease-out forwards'
            }}>
                <style>{`
                    @keyframes fadeInOverlay {
                        from { opacity: 0; }
                        to { opacity: 1; }
                    }
                    @keyframes pulseLogo {
                        0% { transform: scale(0.95); opacity: 0.85; filter: drop-shadow(0 0 10px rgba(255,255,255,0.1)); }
                        50% { transform: scale(1.05); opacity: 1; filter: drop-shadow(0 0 25px rgba(255,255,255,0.3)); }
                        100% { transform: scale(0.95); opacity: 0.85; filter: drop-shadow(0 0 10px rgba(255,255,255,0.1)); }
                    }
                    @keyframes rotateSpinner {
                        to { transform: rotate(360deg); }
                    }
                `}</style>
                <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    gap: '24px',
                    textAlign: 'center',
                    padding: '32px',
                    borderRadius: '24px',
                    background: 'rgba(255, 255, 255, 0.03)',
                    border: '1px solid rgba(255, 255, 255, 0.08)',
                    boxShadow: '0 20px 50px rgba(0, 0, 0, 0.3)',
                    maxWidth: '400px',
                    width: '90%'
                }}>
                    <div style={{ position: 'relative', width: '90px', height: '90px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <img
                            src="/CDP_logo.png"
                            alt="CDP Logo"
                            style={{
                                width: '64px',
                                height: '64px',
                                objectFit: 'contain',
                                animation: 'pulseLogo 2s ease-in-out infinite',
                                zIndex: 2
                            }}
                        />
                        <div style={{
                            position: 'absolute',
                            width: '84px',
                            height: '84px',
                            borderRadius: '50%',
                            border: '3px solid transparent',
                            borderTopColor: '#003380',
                            borderRightColor: '#0044ff',
                            animation: 'rotateSpinner 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite',
                            zIndex: 1
                        }}></div>
                    </div>
                    <div>
                        <h3 style={{
                            color: 'white',
                            margin: '0 0 8px 0',
                            fontSize: '1.25rem',
                            fontWeight: '700',
                            letterSpacing: '-0.025em'
                        }}>
                            A carregar...
                        </h3>
                        {storedName && (
                            <p style={{
                                color: '#94a3b8',
                                margin: 0,
                                fontSize: '0.95rem',
                                fontWeight: '500'
                            }}>
                                A entrar como <span style={{ color: '#60a5fa', fontWeight: '600' }}>{storedName}</span>
                            </p>
                        )}
                    </div>
                </div>
            </div>
        );
    }
    if (error || !coachData) {
        return (
            <div className="dashboard-error" style={{ padding: '140px 24px 40px', textAlign: 'center', color: '#0f172a' }}>
                <h2>Não foi possível carregar o dashboard</h2>
                <p>{error || 'Sem dados do utilizador.'}</p>
                <button onClick={() => window.location.reload()} style={{ marginRight: 12 }}>Tentar novamente</button>
                <button onClick={() => navigate('/login')}>Ir para login</button>
            </div>
        );
    }

    if (showCalendarManager && selectedTeamId) {
        return (
            <div className="dashboard-wrapper">
                <div className="container" style={{ padding: '20px 0' }}>
                    <CalendarManager
                        restrictedTeamId={selectedTeamId}
                        onBack={() => { setShowCalendarManager(false); fetchData(); }}
                        isCoachDashboard={true}
                    />
                </div>
            </div>
        );
    }

    const isAssistant = !!coachData.coachProfile?.isAssistant;

    return (
        <div className="dashboard-wrapper">
            {isSwitchingUser && (
                <div style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: 'rgba(0, 15, 38, 0.9)',
                    backdropFilter: 'blur(10px)',
                    WebkitBackdropFilter: 'blur(10px)',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    zIndex: 99999,
                    animation: 'fadeInOverlay 0.3s ease-out forwards'
                }}>
                    <style>{`
                        @keyframes fadeInOverlay {
                            from { opacity: 0; }
                            to { opacity: 1; }
                        }
                        @keyframes pulseLogo {
                            0% { transform: scale(0.95); opacity: 0.85; filter: drop-shadow(0 0 10px rgba(255,255,255,0.1)); }
                            50% { transform: scale(1.05); opacity: 1; filter: drop-shadow(0 0 25px rgba(255,255,255,0.3)); }
                            100% { transform: scale(0.95); opacity: 0.85; filter: drop-shadow(0 0 10px rgba(255,255,255,0.1)); }
                        }
                        @keyframes rotateSpinner {
                            to { transform: rotate(360deg); }
                        }
                    `}</style>
                    <div style={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        gap: '24px',
                        textAlign: 'center',
                        padding: '32px',
                        borderRadius: '24px',
                        background: 'rgba(255, 255, 255, 0.03)',
                        border: '1px solid rgba(255, 255, 255, 0.08)',
                        boxShadow: '0 20px 50px rgba(0, 0, 0, 0.3)',
                        maxWidth: '400px',
                        width: '90%'
                    }}>
                        <div style={{ position: 'relative', width: '90px', height: '90px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                            <img
                                src="/CDP_logo.png"
                                alt="CDP Logo"
                                style={{
                                    width: '64px',
                                    height: '64px',
                                    objectFit: 'contain',
                                    animation: 'pulseLogo 2s ease-in-out infinite',
                                    zIndex: 2
                                }}
                            />
                            <div style={{
                                position: 'absolute',
                                width: '84px',
                                height: '84px',
                                borderRadius: '50%',
                                border: '3px solid transparent',
                                borderTopColor: '#003380',
                                borderRightColor: '#0044ff',
                                animation: 'rotateSpinner 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite',
                                zIndex: 1
                            }}></div>
                        </div>
                        <div>
                            <h3 style={{
                                color: 'white',
                                margin: '0 0 8px 0',
                                fontSize: '1.25rem',
                                fontWeight: '700',
                                letterSpacing: '-0.025em'
                            }}>
                                A alterar perfil...
                            </h3>
                            {switchingToName && (
                                <p style={{
                                    color: '#94a3b8',
                                    margin: 0,
                                    fontSize: '0.95rem',
                                    fontWeight: '500'
                                }}>
                                    A entrar como <span style={{ color: '#60a5fa', fontWeight: '600' }}>{switchingToName}</span>
                                </p>
                            )}
                        </div>
                    </div>
                </div>
            )}
            <div className="dashboard-bg-decoration">
                <div className="blob blob-1"></div>
            </div>

            {paymentToast && (
                <div className={`payment-toast ${paymentToast}`}>
                    <div className="toast-content">
                        <div className={`toast-icon ${paymentToast}`}>
                            <i className={paymentToast === 'success' ? 'fas fa-check-circle' : 'fas fa-exclamation-circle'}></i>
                        </div>
                        <div className="toast-text">
                            <strong>
                                {paymentToast === 'success' ? 'Pagamento Concluído!' : 'Pagamento Interrompido'}
                            </strong>
                            <p>
                                {paymentToast === 'success'
                                    ? 'O processo foi iniciado com sucesso. Poderá demorar alguns minutos a atualizar no sistema.'
                                    : 'O processo de pagamento foi cancelado. Pode tentar novamente quando desejar.'}
                            </p>
                        </div>
                        <button className="toast-close" onClick={() => setPaymentToast(null)}>
                            <i className="fas fa-times"></i>
                        </button>
                    </div>
                </div>
            )}

            {linkedUsers.length > 1 && (
                <div className="athlete-tabs">
                    <div className="container athlete-tabs-container">
                        {linkedUsers.map((lu) => (
                            <button
                                key={lu.id}
                                onClick={() => handleLinkedTabClick(lu)}
                                className={`athlete-tab ${currentUserId === lu.id ? 'active' : ''} ${lu.requiresConsent ? 'is-blocked' : ''}`}
                                title={lu.requiresConsent ? 'Requer Autorização (18+ anos)' : lu.requiresPin ? 'Requer PIN (18+ anos)' : ''}
                            >
                                {lu.requiresConsent ? (
                                    <FaLock style={{ color: '#ef4444', marginRight: '6px' }} />
                                ) : lu.requiresPin ? (
                                    <FaLock style={{ color: '#eab308', marginRight: '6px' }} />
                                ) : null}
                                {`${lu.firstName} ${lu.lastName}`.trim() || `Conta ${lu.id}`}
                            </button>
                        ))}
                    </div>
                </div>
            )}

            <header className="profile-header">
                <div className="container">
                    <div className="profile-content">
                        <div className="profile-content-left">
                            <div className="treinador-avatar-wrapper" onClick={() => setIsEditModalOpen(true)} title="Alterar foto de perfil">
                                <img
                                    src={coachData?.profilePhotoUrl
                                        ? `${API_BASE_URL}${coachData.profilePhotoUrl}`
                                        : "https://images.unsplash.com/vector-1742875355318-00d715aec3e8?q=80&w=880&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"}
                                    alt={coachData.fullName}
                                    className="profile-avatar"
                                    onError={(e) => { e.target.src = "https://images.unsplash.com/vector-1742875355318-00d715aec3e8?q=80&w=880&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"; }}
                                />
                                <div className="treinador-avatar-overlay"><i className="fas fa-camera"></i></div>
                            </div>
                            <div className="profile-info">
                                <h1>{coachData.fullName}</h1>
                                <div className="profile-meta">
                                    <div className="profile-meta-item">
                                        <i className="fas fa-basketball-ball"></i>
                                        <span>{coachData.coachProfile?.sportName || 'N/A'}</span>
                                    </div>
                                    <div className="profile-meta-item">
                                        <i className="fas fa-users"></i>
                                        {coachData.coachProfile?.teams?.length > 1 ? (
                                            <select
                                                value={selectedTeamId}
                                                onChange={(e) => {
                                                    const id = parseInt(e.target.value);
                                                    setSelectedTeamId(id);
                                                    fetchTeamData(id);
                                                }}
                                                className="team-switcher-select"
                                            >
                                                {coachData.coachProfile.teams.map(t => (
                                                    <option key={t.id} value={t.id}>{t.name}{t.season ? ` (${t.season})` : ''}</option>
                                                ))}
                                            </select>
                                        ) : (
                                            <span>{teamData?.name || 'Sem Equipa Atribuída'}</span>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                        {isAlsoAtleta && (
                            <button
                                className="role-switch-btn"
                                onClick={() => navigate('/dashboard-atleta')}
                                title="Ver Dashboard Atleta"
                            >
                                <i className="fas fa-running"></i>
                                <span>Ver como Atleta</span>
                            </button>
                        )}
                        {isAssistant && !isAlsoAtleta && userRoles.includes('socio') && (
                            <button
                                className="role-switch-btn"
                                onClick={() => navigate('/dashboard-socio')}
                                title="Ver Dashboard Sócio"
                            >
                                <i className="fas fa-id-card"></i>
                                <span>Ver como Sócio</span>
                            </button>
                        )}
                        {isAlsoCoordenador && (
                            <button
                                className="role-switch-btn"
                                onClick={() => navigate('/dashboard-coordenador')}
                                title="Ver Dashboard Coordenador"
                            >
                                <i className="fas fa-users-cog"></i>
                                <span>Ver como Coordenador</span>
                            </button>
                        )}
                    </div>
                </div>
            </header>

            {!isAssistant && (
            <section className="quick-stats">
                <div className="container">
                    <div className="treinador-stats-grid">
                        <div className="stat-card">
                            <h3>{teamData?.athletes?.length || '-'}</h3>
                            <p>Atletas na Equipa</p>
                        </div>
                        <div className="stat-card">
                            <h3>
                                {teamRecord.wins}
                                {teamRecord.draws > 0 ? ` - ${teamRecord.draws}E ` : ' '}
                                - {teamRecord.losses}
                            </h3>
                            <p>Vitórias - Derrotas</p>
                        </div>
                        <div className="stat-card">
                            <h3>{coachData.coachProfile?.yearsExp || '1+'}</h3>
                            <p>Épocas no Clube</p>
                        </div>
                    </div>
                </div>
            </section>
            )}

            <section>
                <div className="container">
                    <div className="dashboard-content">
                        <div className="dashboard-main-column">
                            <div className="dashboard-card">
                                <div className="dashboard-card-header">
                                    <div className="header-with-tabs">
                                        <h2><i className="far fa-calendar"></i> Calendário da Equipa</h2>
                                        <div className="event-tabs">
                                            <button
                                                className={`event-tab-btn ${activeEventTab === 'upcoming' ? 'active' : ''}`}
                                                onClick={() => setActiveEventTab('upcoming')}
                                            >
                                                Próximos
                                            </button>
                                            <button
                                                className={`event-tab-btn ${activeEventTab === 'past' ? 'active' : ''}`}
                                                onClick={() => setActiveEventTab('past')}
                                            >
                                                Passados
                                            </button>
                                        </div>
                                    </div>
                                    <button className="view-all-link" onClick={() => setIsCalendarModalOpen(true)} style={{ background: 'none', border: 'none', cursor: 'pointer' }}>
                                        Ver Tudo <i className="fas fa-arrow-right"></i>
                                    </button>
                                </div>

                                <div className="events-list">
                                    {(activeEventTab === 'upcoming' ? events : pastEvents).length > 0 ? (
                                        (activeEventTab === 'upcoming' ? events : pastEvents).map(event => (
                                            <div key={event.id} className="event-item">
                                                <div className="event-date">
                                                    <span className="day">{new Date(event.startDateTime).toLocaleDateString('pt-PT', { day: '2-digit' })}</span>
                                                    <span className="month">{new Date(event.startDateTime).toLocaleDateString('pt-PT', { month: 'short' }).replace('.', '')}</span>
                                                </div>
                                                <div className="event-details">
                                                    <h4>
                                                        {event.eventType === 1 ? 'Jogo: ' : event.eventType === 2 ? 'Treino: ' : ''}
                                                        {event.title}
                                                    </h4>
                                                    <div className="event-meta">
                                                        <span><i className="far fa-clock"></i> {new Date(event.startDateTime).toLocaleTimeString('pt-PT', { hour: '2-digit', minute: '2-digit' })}</span>
                                                        {event.location && <span><i className="fas fa-map-marker-alt"></i> {event.location}</span>}
                                                    </div>
                                                </div>

                                                <div className="event-actions">
                                                    {event.eventType === 2 && (
                                                        <button
                                                            className="action-btn-small action-btn-attendance"
                                                            onClick={() => { setSelectedEventForAttendance(event); setIsAttendanceModalOpen(true); }}
                                                            title="Presenças"
                                                        >
                                                            <i className="fas fa-clipboard-check"></i> Presenças
                                                        </button>
                                                    )}
                                                    {event.eventType === 1 && !isAssistant && (
                                                        <button
                                                            className={`action-btn-small action-btn-callup ${activeEventTab === 'past' ? 'is-past' : ''}`}
                                                            onClick={() => { setSelectedEventForCallUp(event); setIsCallUpModalOpen(true); }}
                                                            title={activeEventTab === 'past' ? "Ver Convocatória" : "Convocar"}
                                                        >
                                                            <i className={`fas ${activeEventTab === 'past' ? 'fa-lock' : 'fa-bullhorn'}`}></i> {activeEventTab === 'past' ? 'Convocatória' : 'Convocar'}
                                                        </button>
                                                    )}
                                                </div>
                                            </div>
                                        ))
                                    ) : (
                                        <div className="empty-state" style={{ textAlign: 'center', padding: '30px', color: '#94a3b8' }}>
                                            {activeEventTab === 'upcoming' ? 'Não existem eventos agendados.' : 'Não existem eventos passados recentes.'}
                                        </div>
                                    )}
                                </div>
                            </div>

                            <div className="dashboard-card" style={{ marginTop: '32px' }}>
                                <div className="dashboard-card-header">
                                    <h2><i className="fas fa-users"></i> Atletas ({teamData?.athletes?.length || 0})</h2>
                                    <div style={{ display: 'flex', gap: '16px', alignItems: 'center' }}>
                                        {!isAssistant && (
                                        <button className="view-all-link" onClick={() => setIsCallUpHistoryOpen(true)} style={{ background: 'none', border: 'none', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '6px' }}>
                                            <i className="fas fa-bullhorn"></i> Jogos
                                        </button>
                                        )}
                                        <button className="view-all-link" onClick={() => setIsAttendanceHistoryOpen(true)} style={{ background: 'none', border: 'none', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '6px' }}>
                                            <i className="fas fa-history"></i> Treinos
                                        </button>
                                        <button className="view-all-link" onClick={() => setIsTeamModalOpen(true)} style={{ background: 'none', border: 'none', cursor: 'pointer' }}>
                                            Detalhes <i className="fas fa-arrow-right"></i>
                                        </button>
                                    </div>
                                </div>

                                <div className="athletes-grid">
                                    {(teamData?.athletes || []).slice(0, 6).map((athlete) => {
                                        const athleteStat = teamStats?.athleteStats?.find(s => s.athleteId === athlete.id);
                                        return (
                                            <div className="athlete-item" key={athlete.id}>
                                                <div className="athlete-avatar">
                                                    {athlete.jerseyNumber || athlete.name.split(' ').map(n => n[0]).join('').substring(0, 2).toUpperCase()}
                                                </div>
                                                <div className="athlete-info">
                                                    <h4>{athlete.name}</h4>
                                                    <p>{athlete.position || 'Atleta'}</p>
                                                </div>
                                                {!isAssistant && (() => {
                                                    const pay = athletePayments[athlete.userId];
                                                    if (!pay) return null;
                                                    const cfg = pay.status === 'EmDia'
                                                        ? { color: '#10b981', bg: 'rgba(16,185,129,0.12)', icon: 'fa-check-circle', label: 'Em dia', title: 'Pagamento em dia' }
                                                        : pay.status === 'EmAtraso'
                                                            ? { color: '#ef4444', bg: 'rgba(239,68,68,0.12)', icon: 'fa-exclamation-circle', label: 'Em atraso', title: `Quotas em atraso: ${pay.monthsOverdue} ${pay.monthsOverdue === 1 ? 'mês' : 'meses'}` }
                                                            : { color: '#94a3b8', bg: 'rgba(148,163,184,0.15)', icon: 'fa-question-circle', label: 'N/D', title: 'Sem perfil de sócio' };
                                                    return (
                                                        <div title={cfg.title} style={{ display: 'inline-flex', alignItems: 'center', gap: '4px', padding: '3px 8px', borderRadius: '999px', fontSize: '0.7rem', fontWeight: 600, color: cfg.color, background: cfg.bg, whiteSpace: 'nowrap' }}>
                                                            <i className={`fas ${cfg.icon}`}></i> {cfg.label}
                                                        </div>
                                                    );
                                                })()}
                                                {athleteStat && (
                                                    <div className="athlete-stat-badge" title="Assiduidade Individual">
                                                        {athleteStat.rate}%
                                                    </div>
                                                )}
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>

                            {!isAssistant && (
                            <div className="dashboard-card" style={{ marginTop: '24px' }}>
                                <div className="dashboard-card-header">
                                    <h2><i className="fas fa-bullhorn"></i> Notificações</h2>
                                </div>
                                <div className="notifications-placeholder" style={{ textAlign: 'center', padding: '30px', color: '#94a3b8', background: 'rgba(0, 51, 128, 0.02)', borderRadius: '16px' }}>
                                    <i className="fas fa-bell-slash" style={{ fontSize: '2rem', marginBottom: '12px', display: 'block', color: '#cbd5e1' }}></i>
                                    <p style={{ margin: '0', fontSize: '0.9rem', fontWeight: '500' }}>Não existem notificações recentes.</p>
                                </div>
                            </div>
                            )}
                        </div>

                        <aside className="dashboard-side-column">
                            {!isAssistant && (
                            <PaymentCard
                                paymentStatus={paymentStatus}
                                quotaAmount={quotaAmount}
                                totalDue={totalDue}
                                overdueMonths={overdueMonths}
                                futureMonths={futureMonths}
                                paymentPreference={paymentPreference}
                                paymentReference={paymentReference}
                                breakdown={quotaBreakdown}
                                discountsApplied={discountsApplied}
                                inscriptionInfo={inscriptionInfo}
                                nextPeriod={nextPeriod}
                                paymentHistory={paymentHistory}
                                historyInscriptions={historyInscriptions}
                                historyYear={historyYear}
                                onHistoryYearChange={setHistoryYear}
                                onGenerateReference={handleStartPayment}
                                generatingReference={startingPayment}
                                onStartPayment={handleStartPayment}
                                startingPayment={startingPayment}
                                parentsPaymentWarning={parentsPaymentWarning}
                                isPollingPayment={isPollingPayment}
                            />
                            )}

                            {!isAssistant && (
                            <div className="dashboard-card glass-card">
                                <div className="dashboard-card-header">
                                    <h2><i className="fas fa-bolt"></i> Ações Rápidas</h2>
                                </div>
                                <div className="quick-actions-grid">
                                    <button className="q-action-item" onClick={() => setIsEditModalOpen(true)}>
                                        <div className="q-icon"><i className="fas fa-user-pen"></i></div>
                                        <span>Editar Perfil</span>
                                    </button>
                                    <button className="q-action-item" onClick={() => setShowCalendarManager(true)}>
                                        <div className="q-icon"><i className="fas fa-calendar-plus"></i></div>
                                        <span>Editar Calendário</span>
                                    </button>
                                    <button className="q-action-item" onClick={() => setIsFamilyModalOpen(true)}>
                                        <div className="q-icon"><i className="fas fa-user-friends"></i></div>
                                        <span>Associar Familiar</span>
                                    </button>
                                    <button className="q-action-item" onClick={() => setIsReceiptsModalOpen(true)}>
                                        <div className="q-icon"><i className="fas fa-file-invoice"></i></div>
                                        <span>Ver Recibos</span>
                                    </button>
                                    <button className="q-action-item" onClick={() => navigate(`/dashboard-treinador/team/${selectedTeamId}/report`)}>
                                        <div className="q-icon"><i className="fas fa-chart-line"></i></div>
                                        <span>Relatório</span>
                                    </button>
                                    <button className="q-action-item" onClick={() => setIsNotificationModalOpen(true)}>
                                        <div className="q-icon"><i className="fas fa-envelope"></i></div>
                                        <span>Notificar</span>
                                    </button>
                                    <button className="q-action-item" onClick={() => setIsTicketsModalOpen(true)}>
                                        <div className="q-icon" style={{ background: '#003380', color: 'white' }}><i className="fas fa-ticket-alt"></i></div>
                                        <span>Bilhetes</span>
                                    </button>
                                    <button className="q-action-item" onClick={() => setIsDocumentsModalOpen(true)}>
                                        <div className="q-icon" style={{ background: '#0e7490', color: 'white' }}><i className="fas fa-file-pdf"></i></div>
                                        <span>Documentos</span>
                                    </button>
                                    <button className="q-action-item" onClick={() => setIsPinModalOpen(true)}>
                                        <div className="q-icon" style={{ background: '#d97706', color: 'white' }}><i className="fas fa-key"></i></div>
                                        <span>Alterar PIN</span>
                                    </button>
                                </div>
                            </div>
                            )}

                            {/* Membership Card */}
                            {coachData && !isAssistant && (
                                <MembershipCard
                                    memberNumber={coachData.memberProfile?.membershipNumber || coachData.id?.toString()}
                                    name={coachData.fullName || `${coachData.firstName || ''} ${coachData.lastName || ''}`.trim()}
                                    memberSince={coachData.memberProfile?.memberSince ? new Date(coachData.memberProfile.memberSince).getFullYear().toString() : (coachData.createdAt ? new Date(coachData.createdAt).getFullYear().toString() : '—')}
                                    status={coachData.memberProfile?.membershipStatus !== undefined
                                        ? ['Pending', 'Active', 'Suspended', 'Cancelled'][coachData.memberProfile.membershipStatus] || 'Ativo'
                                        : 'Ativo'}
                                    sport={coachData.coachProfile?.sportName || coachData.sport || 'CD Póvoa'}
                                    cardType="socio"
                                    userId={currentUserId}
                                    compact={true}
                                    photoUrl={coachData.profilePhotoUrl}
                                    paymentState={getCardPaymentState(paymentStatus, overdueMonths)}
                                />
                            )}

                            <div className="dashboard-card">
                                <div className="dashboard-card-header">
                                    <h2><i className="fas fa-check-circle"></i> Último Treino</h2>
                                </div>
                                {lastTrainingStats ? (
                                    <div className="attendance-summary">
                                        <div className="attendance-meta">
                                            <span className="attendance-date">{new Date(lastTrainingStats.date).toLocaleDateString()}</span>
                                            <span className="attendance-count">{lastTrainingStats.present}/{lastTrainingStats.total} Presentes</span>
                                        </div>
                                        <div className="attendance-progress-bg">
                                            <div className="attendance-progress-bar" style={{
                                                width: `${lastTrainingStats.rate}%`,
                                                background: lastTrainingStats.rate > 75 ? '#10b981' : lastTrainingStats.rate > 50 ? '#f59e0b' : '#ef4444'
                                            }}></div>
                                        </div>
                                    </div>
                                ) : (
                                    <div className="empty-state" style={{ textAlign: 'center', color: '#94a3b8', fontSize: '0.9rem' }}>Sem dados recentes.</div>
                                )}
                            </div>

                        </aside>
                    </div>
                </div>
            </section>

            <TeamDetailsModal isOpen={isTeamModalOpen} onClose={() => setIsTeamModalOpen(false)} teamData={teamData} isEditable={!isAssistant} onTeamUpdate={fetchData} athletePayments={isAssistant ? {} : athletePayments} />
            <CalendarModal isOpen={isCalendarModalOpen} onClose={() => setIsCalendarModalOpen(false)} teamId={selectedTeamId} />
            <TeamCallUpHistoryModal
                isOpen={isCallUpHistoryOpen}
                onClose={() => setIsCallUpHistoryOpen(false)}
                teamId={selectedTeamId}
                athletes={teamData?.athletes || []}
                sportName={teamData?.sportName}
            />
            <EventAttendanceModal isOpen={isAttendanceModalOpen} onClose={() => { setIsAttendanceModalOpen(false); if (selectedTeamId) fetchTeamData(selectedTeamId); }} event={selectedEventForAttendance} teamId={selectedTeamId} />
            <TeamAttendanceHistoryModal
                isOpen={isAttendanceHistoryOpen}
                onClose={() => { setIsAttendanceHistoryOpen(false); if (selectedTeamId) fetchTeamData(selectedTeamId); }}
                teamId={selectedTeamId}
                athletes={teamData?.athletes || []}
                teamName={teamData?.name}
                sportName={teamData?.sportName}
                season={teamData?.season}
            />

            <GameCallUpModal isOpen={isCallUpModalOpen} onClose={() => setIsCallUpModalOpen(false)} event={selectedEventForCallUp} teamId={selectedTeamId} />

            <FamilyAssociationModal isOpen={isFamilyModalOpen} onClose={() => setIsFamilyModalOpen(false)} />

            <DocumentsModal isOpen={isDocumentsModalOpen} onClose={() => setIsDocumentsModalOpen(false)} userId={currentUserId} userType="treinador" />

            <ReceiptsModal isOpen={isReceiptsModalOpen} onClose={() => setIsReceiptsModalOpen(false)} userId={currentUserId} />

            <EditProfileModal
                isOpen={isEditModalOpen}
                onClose={() => setIsEditModalOpen(false)}
                userData={coachData}
                onSave={handleSaveProfile}
            />

            <NotificationModal
                isOpen={isNotificationModalOpen}
                onClose={() => setIsNotificationModalOpen(false)}
                teamData={teamData}
            />

            <TicketsModal
                isOpen={isTicketsModalOpen}
                onClose={() => setIsTicketsModalOpen(false)}
                userId={currentUserId}
            />

            <ChangePinModal
                isOpen={isPinModalOpen}
                onClose={() => setIsPinModalOpen(false)}
                userType="treinador"
            />

            <AdminPinModal
                isOpen={showAdminPinModal}
                targetUserId={pendingSwitchUser?.id}
                onSuccess={() => {
                    setShowAdminPinModal(false);
                    if (pendingSwitchUser) executeUserSwitch(pendingSwitchUser);
                }}
                onClose={() => setShowAdminPinModal(false)}
            />

            <ConsentRequestModal
                isOpen={showConsentModal}
                targetUser={targetConsentUser}
                onClose={() => setShowConsentModal(false)}
                onRequestSent={() => refreshLinkedUsers()}
            />

            <FamilyPrivacyModal
                isOpen={isPrivacyModalOpen}
                onClose={() => setIsPrivacyModalOpen(false)}
            />
        </div>
    );
};

export default DashboardTreinador;
